import React, {Component} from 'react';
import {CONFIG_PAGE_ROWS} from "../constants/constants";
import {refreshToken} from "../services/UsersService";
import {Spin} from 'antd';

class EntriesIterator extends Component {

    handleFilterSearch = (selectedKeys, confirm) => () => {
        confirm();
        this.setState({customFilterEntries: selectedKeys});
    };

    handleFilterReset = clearFilters => () => {
        clearFilters();
        this.setState({customFilterEntries: ''});
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            page: 0,
            rows: CONFIG_PAGE_ROWS,
            total: 0,
            customFilterEntries: [],
            editVisible: false
        };
        this.onPage = this.onPage.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
    }

    resetAll(callback) {
        this.setState({
            isLoading: false,
            page: 0,
            rows: CONFIG_PAGE_ROWS,
            total: 0,
            customFilterEntries: [],
            editVisible: false
        }, () => callback);
    }

    handleStateChange(pagination, filters, sorters) {
        this.setState({
            filters: filters,
            sorters: sorters,
        });
        let current = pagination && pagination.current ? pagination.current : 1;
        this.onPage(current - 1, filters)
    }

    onPage(page, filters, callback) {
        this.setState({
            loading: true
        });

        this.processPaginatedRequest(page, this.state.rows, filters).then(response => {
            const content = [];
            if (response && response.content) {
                response.content.forEach(function (entry) {
                    content.push(entry)
                });

                this.setState({
                    data: content,
                    page: page,
                    total: response.totalElements,
                    loading: false,
                    isLoading: false
                }, callback);
            }
        });
    }

    getPagination() {
        return {
            pageSize: this.state.rows,
            total: this.state.total,
            showTotal: (total, range) => `${range[0]}-${range[1]} ${'de'} ${total} ${'elementos'}`
        }
    }

    componentDidMount() {
        this.setState({
            isLoading: true
        });
        this.onPage(0);
        refreshToken();
    }

    render() {
        if (this.state.isLoading) {
            return <Spin size="large"/>;
        }
        return <div>
            {
                this.state.data ? (this.renderView()) : <p>Sin resultados</p>
            }
        </div>
    }
}

export default EntriesIterator;


// WEBPACK FOOTER //
// ./src/app/components/EntriesIterator.js